module.exports = __webpack_public_path__ + "static/media/monica_cruz2.d9180b8b.jpg";